import { Helmet } from 'react-helmet'

import { APP } from '@/common/strings'
import ProfileSettingsView from './ProfileSettingsView'
import { useFetchPayId } from '@/wallet/walletQueries'
import { H1 } from '@/common/ui'
import useAccountStore from '@/account/accountStore'

export function Profile() {
    const activeAccountId = useAccountStore((s) => s.activeAccountId)
    useFetchPayId(activeAccountId)

    return (
        <>
            <Helmet>
                <title>Profile | {APP.title}</title>
            </Helmet>
            <H1>Profile</H1>
            <ProfileSettingsView />
        </>
    )
}
